// src/index.ts
function roundToCurrency(value) {
  return Math.round(value * 100) / 100;
}
function findApplicableTierPrice(quantity, tiers, basePrice) {
  if (!tiers?.length) return null;
  let applicable = null;
  for (const tier of tiers) {
    if (quantity >= tier.fromQuantity) {
      applicable = tier;
    } else {
      break;
    }
  }
  if (!applicable) return null;
  return applicable.hasCustomPrice ? parseFloat(applicable.price) : roundToCurrency(basePrice * (1 - applicable.percentage / 100));
}
function getEffectivePrice(input) {
  const { standardPrice, customerPrice, quantity, discountTiers } = input;
  const bulkPrice = findApplicableTierPrice(quantity, discountTiers, standardPrice);
  const candidates = [
    { price: standardPrice, type: "standard" }
  ];
  if (customerPrice !== void 0) {
    candidates.push({ price: customerPrice, type: "customer" });
  }
  if (bulkPrice !== null) {
    candidates.push({ price: bulkPrice, type: "bulk" });
  }
  const best = candidates.reduce((a, b) => a.price <= b.price ? a : b);
  return {
    effectivePrice: best.price,
    priceType: best.type
  };
}
export {
  findApplicableTierPrice,
  getEffectivePrice
};
